import { useEffect, useState } from "react";
import './App.css';
import { auth } from './firebase';
import { useSetNotifications } from './functions/notifications';
import './mobile.css';
import Appointment from './Screens/Appointment';
import Chat from './Screens/Chat';
import Home from './Screens/Home';
import SignUp from './Screens/SignUp';

function App() {

    const [user, setUser] = useState(null)
    const [loading, setLoading] = useState(true)
    const [navigate, setNavigation] = useState("home")
    const notify = useSetNotifications(user)

    const navigation = {
        navigate: e => setNavigation(e),
        goBack: () => setNavigation("home")
    }

    useEffect(() => {

        auth?.onAuthStateChanged(res => {

            setUser(res?.uid || null)
            setLoading(false)

        })

    }, [])

    return (
        <>
            <div style={{ position: "fixed", top: 0, width: "100vw", height: "100vh", overflow: "hidden" }}>
                <div className="container">
                    {!user ? (
                            <SignUp />
                        ) : (
                        <Home navigation={navigation} />
                    )}
                </div>
                <div className="wrapper-item" style={{ position: "fixed", top: navigate === "appointment" ? 0 : window.innerHeight }}>
                    <div style={{ position: "relative" }}>
                        <Appointment navigation={navigation} />
                    </div>
                </div>
                <div className="wrapper-item" style={{ position: "fixed", top: navigate === "chat" ? 0 : window.innerHeight }}>
                    <div style={{ position: "relative" }}>
                        <Chat navigation={navigation} />
                    </div>
                </div>
            </div>
            {loading && (
                <div style={{ 
                    position: "fixed",
                    top: 0,
                    width: "100vw",
                    height: "100vh",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    backgroundColor: "rgba(0,0,0,0.7)"
                }}>
                    <p style={{ color: "#FFF"}}>Loading...</p>
                </div>
            )}
        </>
    );
}

export default App;
